import Button from 'admin/components/atoms/Buttons';
import SchemaFilterForm from 'admin/components/shared/SchemaFilterForm';
import Textbox from 'admin/components/shared/Textbox';
import { toQueryParams } from 'admin/utils';
import _ from 'lodash';
import React, { Component } from 'react';
import CSSModules from 'react-css-modules';
import DateTimeRange from '../../atoms/DateTimeRange';
import styles from './styles.scss';

class CustomerFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      customer_id: '',
      customer_tel: '',
      customer_email: '',
      customer_name: '',
      registered_from: null,
      registered_to: null,
      user_attribute_queries: {},
    };
  }

  onSubmit = (e) => {
    e.preventDefault();
    this.setState({ customer_tel: this.state.customer_tel.trim() }, () => {
      const {
        customer_id,
        customer_tel,
        customer_email,
        customer_name,
        registered_to,
        registered_from,
        user_attribute_queries,
      } = this.state;
      const params = Object.assign(
        {
          private_money_id: this.props.privateMoneyId,
        },
        _.isEmpty(user_attribute_queries) ? {} : { user_attribute_queries },
        customer_id === '' ? {} : { customer_id },
        customer_tel === '' ? {} : { customer_tel },
        customer_email === '' ? {} : { customer_email },
        customer_name === '' ? {} : { customer_name },
        registered_from ? { registered_from } : {},
        registered_to ? { registered_to } : {}
      );

      this.props.onFilterSubmit(toQueryParams(params));
    });
  };

  onClear = () => {
    this.setState({
      customer_id: '',
      customer_tel: '',
      customer_email: '',
      customer_name: '',
      registered_from: null,
      registered_to: null,
      user_attribute_queries: {},
    });
  };

  onChangeQuery = (key, value) => {
    const userAttributeQueries = Object.assign({}, this.state.user_attribute_queries);
    userAttributeQueries[key] = value;
    this.setState({ user_attribute_queries: userAttributeQueries });
  };

  render() {
    return (
      <form styleName="date-range-picker" autoComplete="off">
        <div styleName="form-group">
          <label styleName="label" htmlFor="customer_id">
            お客様ID
          </label>
          <Textbox
            name="customer_id"
            id="customer_id"
            value={this.state.customer_id}
            onChange={(e) => this.setState({ customer_id: e.target.value })}
            styleName="textbox"
          />
        </div>
        <div styleName="form-group">
          <label styleName="label" htmlFor="customer_tel">
            携帯電話番号
          </label>
          <Textbox
            name="customer_tel"
            id="customer_tel"
            value={this.state.customer_tel}
            onChange={(e) => this.setState({ customer_tel: e.target.value })}
            styleName="textbox"
          />
        </div>
        <div styleName="form-group">
          <label styleName="label" htmlFor="customer_email">
            メールアドレス
          </label>
          <Textbox
            name="customer_email"
            id="customer_email"
            value={this.state.customer_email}
            onChange={(e) => this.setState({ customer_email: e.target.value })}
            styleName="textbox"
          />
        </div>
        <div styleName="form-group">
          <label styleName="label" htmlFor="customer_name">
            ニックネーム
          </label>
          <Textbox
            name="customer_name"
            id="customer_name"
            value={this.state.customer_name}
            onChange={(e) => this.setState({ customer_name: e.target.value })}
            styleName="textbox"
          />
        </div>
        <div styleName="form-group">
          <label styleName="label" htmlFor="registered_from">
            会員登録日時
          </label>
          <DateTimeRange
            wrapperStyles={{ display: 'inline-flex' }}
            dateRange={{
              from: this.state.registered_from,
              to: this.state.registered_to,
            }}
            dateTimeProps={{
              fromProps: {
                inputProps: { id: 'registered_from', name: 'registered_from' },
                showIcon: true,
              },
              toProps: {
                inputProps: { id: 'registered_to', name: 'registered_to' },
                showIcon: true,
              },
            }}
            setDateRange={({ from, to }) =>
              this.setState({ registered_from: from, registered_to: to })
            }
          />
        </div>
        {this.props.privateMoneyId ? (
          <SchemaFilterForm
            onChangeQuery={this.onChangeQuery}
            selectedMoney={this.props.privateMoneyId}
            isClear={Object.keys(this.state.user_attribute_queries).length === 0}
          />
        ) : null}
        <div styleName="form-group">
          <Button
            variant="neutral"
            styleName="btn"
            type="button"
            onClick={this.onClear}
            disabled={!this.props.privateMoneyId}
          >
            クリア
          </Button>
          <Button styleName="btn" onClick={this.onSubmit} disabled={!this.props.privateMoneyId}>
            検索
          </Button>
        </div>
      </form>
    );
  }
}

export default CSSModules(CustomerFilter, styles);
